module.exports = __webpack_public_path__ + "img/heroUI.8d765c5e.png";